<template>
<div class="heading">
  <!-- <img class="background" src="../assets/img/background.jpg"> -->
  <el-button class="scn-btn" type="danger" @click="scanning=true">
    <maximize-icon></maximize-icon> <span class="scan">Scan QR-Code</span>
  </el-button>
  <scan id="modal" :scanning.sync="scanning"></scan>
</div>
</template>

<script>
import { MaximizeIcon } from 'vue-feather-icons';
import EventBus from '../Buss/EventBus';

const Scan = () => import('./Scan');

export default {
  name: 'home',
  data() {
    return {
      scanning: false,
    };
  },
  methods: {
    login() {
      this.$router.push('/login');
    },
  },
  created() {
    // display the webcam from the slide mene
    EventBus.$on('scanning', () => {
      this.scanning = true;
    });
  },
  components: {
    MaximizeIcon,
    Scan,
  },
};
</script>

<!-- You can add "scoped" attribute to limit CSS to this component only -->
<!-- Be carful this can reduce performance -> https://vue-loader.vuejs.org/en/features/scoped-css.html -->
<style>
.heading {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
  /* height: 100%; */
}

.scn-btn {
  padding: 35px;
  font-size: 1.4em;
}
.scan {
  margin-left: 10px;
  top: -5px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// Verify.vue?b2736f12